import { render } from "./KeySquareIcon.vue?vue&type=template&id=0c4bc4e3"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__